module.exports = __webpack_public_path__ + "static/media/web_developer.c93e5bab.svg";